/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';

import {
  DeliveryOrderDetailFragmentDoc,
  CartRestaurantFragmentDoc,
  CartLineItemFragmentDoc,
  CartLedgerFragmentDoc,
  CartDataFragmentDoc,
} from '../../../hooks/useCart/GraphQL/Cart.generated';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DeliveryPreferenceType = 'CURBSIDE' | 'DOOR' | 'LEAVE_AT_DOOR';

export type DressingMode = 'MIXED' | 'NOT_DRESSABLE' | 'ON_THE_SIDE' | 'REMOVED';

export type DressingWeight = 'HEAVY' | 'LIGHT' | 'MEDIUM';

export type IngredientKind = 'BASE' | 'DRESSING' | 'PREMIUM' | 'TOPPING';

export type JoinMultipartyOrderInput = {
  readonly customerName: string;
  readonly joinCode: string;
};

export type ModifierType = 'ADDITION' | 'INCLUDED' | 'MIXED_DRESSING' | 'REMOVAL' | 'SUBSTITUTION';

export type OrderState =
  | 'Active'
  | 'Canceled'
  | 'Complete'
  | 'Discarded'
  | 'LockedChangeLocation'
  | 'LockedCheckout';

export type OrderType =
  | 'CATERING'
  | 'CATERING_DELIVERY'
  | 'CATERING_PICKUP'
  | 'DELIVERY'
  | 'IN_STORE'
  | 'PICKUP';

export type GroupOrderJoinPreviewQueryVariables = Exact<{
  joinCode: string;
}>;

export type GroupOrderJoinPreviewQuery = {
  readonly multipartyOrderPreview:
    | {
        readonly __typename: 'MultipartyOrderAlreadyJoined';
        readonly order: {
          readonly orderType: Types.OrderType;
          readonly restaurant: { readonly id: string; readonly slug: string };
          readonly deliveryOrderDetail: { readonly address: { readonly id: string } | null } | null;
        };
      }
    | { readonly __typename: 'MultipartyOrderNotFound'; readonly errorMessage: string }
    | {
        readonly __typename: 'MultipartyOrderPreviewSuccess';
        readonly hostDisplayName: string;
        readonly deliveryAddressSummary: string | null;
        readonly restaurant: {
          readonly __typename: 'Restaurant';
          readonly id: string;
          readonly name: string;
          readonly isOutpost: boolean;
          readonly address: string;
          readonly city: string;
          readonly state: string;
          readonly zipCode: string;
          readonly slug: string;
        };
      }
    | { readonly __typename: 'OrderLocked'; readonly errorMessage: string };
};

export type GroupOrderJoinMutationVariables = Exact<{
  input: Types.JoinMultipartyOrderInput;
}>;

export type GroupOrderJoinMutation = {
  readonly joinMultipartyOrder:
    | {
        readonly __typename: 'JoinMultipartyOrderSuccess';
        readonly order: {
          readonly __typename: 'Order';
          readonly id: string;
          readonly orderType: Types.OrderType;
          readonly orderState: Types.OrderState;
          readonly canTrackOrderStatus: boolean;
          readonly currentUserOrderPermissions: { readonly canSubmitOrder: boolean };
          readonly multipartyDetails: { readonly joinCode: string } | null;
          readonly ledger: {
            readonly tax: number;
            readonly subtotal: number;
            readonly feesTotal: number;
            readonly discountsTotal: number;
            readonly creditsTotal: number;
            readonly tip: number;
            readonly discounts: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly credits: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly fees: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
          };
          readonly lineItems: ReadonlyArray<{
            readonly __typename: 'LineItem';
            readonly id: string;
            readonly slug: string;
            readonly quantity: number;
            readonly cost: number;
            readonly customName: string | null;
            readonly perItemCost: number;
            readonly favorited: boolean;
            readonly isCustom: boolean;
            readonly dressingMode: Types.DressingMode;
            readonly addedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: { readonly url: string };
            }>;
            readonly removedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: { readonly url: string };
            }>;
            readonly product: {
              readonly __typename: 'Product';
              readonly id: string;
              readonly name: string;
              readonly slug: string;
              readonly isCustom: boolean;
              readonly enableDressingDetails: boolean;
              readonly asset: { readonly url: string };
              readonly ingredients: ReadonlyArray<{
                readonly __typename: 'Ingredient';
                readonly id: string;
                readonly name: string;
                readonly kind: Types.IngredientKind | null;
              }>;
            };
            readonly mixedDressingDetails: ReadonlyArray<{
              readonly ingredientId: string;
              readonly weight: Types.DressingWeight;
            }>;
            readonly selectedModifiers: ReadonlyArray<{
              readonly id: number;
              readonly modifierType: Types.ModifierType | null;
              readonly cost: number;
              readonly parentId: number | null;
              readonly ingredient: {
                readonly id: string;
                readonly name: string;
                readonly kind: Types.IngredientKind | null;
              } | null;
            }>;
          }>;
          readonly restaurant: {
            readonly __typename: 'Restaurant';
            readonly id: string;
            readonly slug: string;
            readonly name: string;
            readonly city: string;
            readonly state: string;
            readonly address: string;
            readonly zipCode: string;
            readonly isOutpost: boolean;
            readonly deliveryMinSubtotal: number;
            readonly showDeliveryFeeDisclosure: boolean;
            readonly availableDropOffLocations: ReadonlyArray<{
              readonly __typename: 'DropOffLocation';
              readonly id: string;
              readonly name: string;
            }>;
            readonly asset: { readonly url: string };
          };
          readonly deliveryOrderDetail: {
            readonly __typename: 'DeliveryOrderDetail';
            readonly id: string;
            readonly tip: number;
            readonly deliveryFee: number;
            readonly vendor: string;
            readonly orderId: string;
            readonly vendorRestaurantId: string;
            readonly estimatedDeliveryTime: string | null;
            readonly address: {
              readonly __typename: 'Address';
              readonly id: string;
              readonly street: string;
              readonly secondaryStreet: string | null;
              readonly city: string;
              readonly state: string;
              readonly country: string;
              readonly zipCode: string;
              readonly deliveryPreference: Types.DeliveryPreferenceType;
              readonly googlePlaceId: string;
              readonly latitude: number;
              readonly longitude: number;
              readonly name: string | null;
              readonly notes: string | null;
            } | null;
          } | null;
        };
      }
    | { readonly __typename: 'MultipartyOrderNotFound'; readonly errorMessage: string }
    | { readonly __typename: 'OrderLocked'; readonly errorMessage: string }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly fieldErrors: ReadonlyArray<{ readonly field: string; readonly message: string }>;
      };
};

export const GroupOrderJoinPreviewDocument = gql`
  query GroupOrderJoinPreview($joinCode: String!) {
    multipartyOrderPreview(joinCode: $joinCode) {
      __typename
      ... on MultipartyOrderAlreadyJoined {
        order {
          orderType
          restaurant {
            id
            slug
          }
          deliveryOrderDetail {
            address {
              id
            }
          }
        }
      }
      ... on MultipartyOrderPreviewSuccess {
        hostDisplayName
        deliveryAddressSummary
        restaurant {
          __typename
          id
          name
          isOutpost
          address
          city
          state
          zipCode
          slug
        }
      }
      ... on MultipartyOrderNotFound {
        errorMessage
      }
      ... on OrderLocked {
        errorMessage
      }
    }
  }
`;

export function useGroupOrderJoinPreviewQuery(
  options: Omit<Urql.UseQueryArgs<GroupOrderJoinPreviewQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GroupOrderJoinPreviewQuery, GroupOrderJoinPreviewQueryVariables>({
    query: GroupOrderJoinPreviewDocument,
    ...options,
  });
}
export const GroupOrderJoinDocument = gql`
  mutation GroupOrderJoin($input: JoinMultipartyOrderInput!) {
    joinMultipartyOrder(input: $input) {
      __typename
      ... on JoinMultipartyOrderSuccess {
        order {
          ...CartData
        }
      }
      ... on MultipartyOrderNotFound {
        errorMessage
      }
      ... on OrderLocked {
        errorMessage
      }
      ... on ValidationError {
        message
        fieldErrors {
          field
          message
        }
      }
    }
  }
  ${CartDataFragmentDoc}
`;

export function useGroupOrderJoinMutation() {
  return Urql.useMutation<GroupOrderJoinMutation, GroupOrderJoinMutationVariables>(
    GroupOrderJoinDocument,
  );
}
